import React from 'react';
import { generatePath } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES, EventLink } from '@atlas/routing';

const BetOutcomeLink = ({ categoryName, children, eventId, sportName, tournamentName }) => {
  const prematchPath = SiteConfigManager.getExtraConfig(
    `pathList.${COMPONENT_TYPES.SPORT_PREMATCH}`,
  );

  const toUrl = React.useMemo(
    () =>
      generatePath(`${prematchPath}/:sportName/:categoryName/:tournamentName`, {
        categoryName,
        sportName,
        tournamentName: encodeURIComponent(tournamentName),
      }),
    [prematchPath, categoryName, sportName, tournamentName],
  );

  return (
    <EventLink className="bet-order-outcome__link" customLocation={toUrl} eventId={eventId}>
      {children}
    </EventLink>
  );
};

export default BetOutcomeLink;
